import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import colors from '../../Utils/colors';
import { BASE_URL } from '../../Config/axiosConfig';

const ShortURL = () => {
  const { code } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  useEffect(() => {
    if (!code) return;

    let finalUrl = `${BASE_URL}api/v2/analytics/openLink?code=${code}`;
    if (id) {
      finalUrl += `&id=${id}`;
    }

    setLoading(false);
    window.open(finalUrl, '_self');
  }, [code, id]);

  return (
    <div
      className="container-fluid d-flex flex-column justify-content-center align-items-center"
      style={{ height: '100vh', width: '100%' }}
    >
      {loading && <Spinner animation="border" style={{ color: colors.primary03 }} />}
    </div>
  );
};

export default ShortURL;